import store from '@state/store'
import lazyLoadView from "./lazyload-view";
import routeError from "./route-error";

export default [
  {
    path: '/:merchantAlias',
    name: 'home',
    component: () => lazyLoadView(import('@views/booking/index')),
    ...routeParamsBooking('light')
  },
  {
    path: '/:merchantAlias/summary',
    name: 'booking-summary',
    component: () => lazyLoadView(import('@views/booking/summary')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentMerchant
          ] = await Promise.all([
            store.dispatch('merchant/fetchMerchant', {
              merchantAlias: routeTo.params.merchantAlias,
            }),
          ]);

          routeTo.params.merchant = currentMerchant.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Merchant' } }));
        }
      },
      showLoginButton: true,
      showShareButton: true,
    },
    props: (route) => ({
      merchant: route.params.merchant || {},
    }),
  },
  {
    path: '/:merchantAlias/:productType(light)',
    redirect: '/:merchantAlias'
  },
  {
    path: '/:merchantAlias/:productType',
    name: 'booking',
    component: () => lazyLoadView(import('@views/booking/index')),
    ...routeParamsBooking()
  },
  {
    path: '/:merchantAlias/:productType/:productId',
    name: 'booking-product',
    component: () => lazyLoadView(import('@views/booking/product')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentProduct,
            currentMerchant,
          ] = await Promise.all([
            store.dispatch('merchant/fetchProduct', {
              productAlias: routeTo.params.productId,
              merchantAlias: routeTo.params.merchantAlias,
            }),
            store.dispatch('merchant/fetchMerchant', {
              merchantAlias: routeTo.params.merchantAlias,
            }),
          ]);
          routeTo.params.merchant = currentMerchant.items;
          routeTo.params.product = currentProduct.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: 'home', params: { merchantAlias: routeTo.params.merchantAlias } }));
        }
      },
      showLoginButton: true,
      showShareButton: true,
    },
    props: (route) => ({
      merchant: route.params.merchant || {},
      product: route.params.product || {}
    }),
  },
]

function routeParamsBooking(productType) {
  return {
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentMerchant,
            currentProducts
          ] = await Promise.all([
            store.dispatch('merchant/fetchMerchant', {
              merchantAlias: routeTo.params.merchantAlias,
            }),
            store.dispatch('merchant/fetchProducts', {
              merchantAlias: routeTo.params.merchantAlias,
              productType: productType || routeTo.params.productType,
            }),
          ]);

          routeTo.params.merchant = currentMerchant.items;
          routeTo.params.products = currentProducts;
          routeTo.params.productType = productType || routeTo.params.productType;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Merchant' } }));
        }
      },
      showShareButton: true,
      showLoginButton: true,
    },
    props: (route) => ({
      merchant: route.params.merchant || {},
      products: route.params.products || [],
    }),
  };
}
